import { Paper } from '@src/state/papers/reducer'
import { createAction, createAsyncAction, createStandardAction } from 'typesafe-actions'

const GET_PAPERS = 'papers/GET_PAPERS'
const SET_PAPERS = 'papers/SET_PAPERS'
const GET_PAPERS_ERROR = 'papers/GET_PAPERS_ERROR'

const DELETE_PAPER_FAIL = 'papers/DELETE_PAPER_FAIL'
const DELETE_PAPER_SUCCESS = 'papers/DELETE_PAPER_SUCCESS'
const DELETE_PAPER = 'papers/DELETE_PAPER'

const TRANSFER_PAPERS = 'papers/TRANSFER_PAPERS'

export interface PapersPayload {
  papers: Paper[]
}

export interface DeletePaperPayload {
  id: string
}

export interface PapersError {
  error: Error
}

export interface TransferPapersPayload {
  oldSessionId: string
}

export const getPapers = createAction(GET_PAPERS)
export const setPapers = createStandardAction(SET_PAPERS)<PapersPayload>()
export const getPapersError = createStandardAction(GET_PAPERS_ERROR)<PapersError>()
export const deletePaper = createAsyncAction(
  DELETE_PAPER,
  DELETE_PAPER_SUCCESS,
  DELETE_PAPER_FAIL
)<DeletePaperPayload, {}, Error>()

export const transferPapers = createStandardAction(TRANSFER_PAPERS)<
  TransferPapersPayload
>()



// WEBPACK FOOTER //
// ./src/state/papers/actions.ts